import { differenceInMonths } from 'date-fns';
import { Department } from '../../api/api-generated';
import { stringIncludesIgnoreCase } from '../../utils/comparisons';
import { getYYYYMMDDForDate } from '../../utils/dateTime';
import { DepartmentFilter } from './departmentsTypes';

export const departmentValidator = (item: any) => {
  if (!item.company && !item.companyId) return false;
  if (!item.departmentName) return false;
  return true;
};

export const departmentMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: any,
  autoboxLabel?: string
) => {
  if (autoboxLabel === 'company') return { company: autoboxValue };
  if (autoboxLabel === 'newHardware')
    return { hardware: [...state.hardware, null] };
  if (autoboxLabel === 'deleteHardware') {
    const index = Number(autoboxValue);
    return {
      hardware: state.hardware
        .slice(0, index)
        .concat(state.hardware.slice(index + 1)),
    };
  }
  if (autoboxLabel?.startsWith('hardware')) {
    const index = Number(autoboxLabel.slice(8));
    const hardwareArrayCopy = [...state.hardware];
    hardwareArrayCopy[index] = autoboxValue;
    return { hardware: hardwareArrayCopy };
  }
  if (name === 'expirationDate')
    return { expirationDate: getYYYYMMDDForDate(new Date(value)) };
  if (name === 'lastContacted')
    return { lastContacted: getYYYYMMDDForDate(new Date(value)) };
  return {};
};

export const filterDepartment = (
  item: Department,
  filters: DepartmentFilter
): boolean => {
  if (
    filters.companyName &&
    !stringIncludesIgnoreCase(item.company.companyName, filters.companyName)
  )
    return false;
  if (
    filters.departmentName &&
    !stringIncludesIgnoreCase(item.departmentName, filters.departmentName)
  )
    return false;
  if (filters.timeToExpiration) {
    const monthDifference = differenceInMonths(
      new Date(item.expirationDate),
      new Date()
    );
    const numberedMonthsForFilter = Number(
      filters.timeToExpiration.slice(0, 1)
    );
    if (monthDifference < 0) return true;
    if (monthDifference <= numberedMonthsForFilter) return true;
    return false;
  }
  return true;
};
